import { APP_PATH } from 'src/config/app-paths';
import { RoutingConfigurationModel } from 'src/core/model/routing-configuration.model';
import { RoleEnum } from 'src/core/model/enum/role.enum';
import { InvoiceDataGrid as InvoiceDataGridV1 } from '@app/feature/invoice-v1/invoice-data-grid/invoice.data-grid';
import { InvoiceDataGrid as InvoiceDataGridV2 } from '@app/feature/invoice-v2/invoice-data-grid/invoice.data-grid';
import { OperatorList } from 'src/feature/user/operator/operator-list/operator-list';
import { AdministratorList } from 'src/feature/user/administrator/administrator-list/administrator-list';
import { DeveloperList } from 'src/feature/user/developer/developer-list/developer-list';
import { CustomerDataGrid } from 'src/feature/customer/customer-data-grid/customer.data-grid';
import { flatRoutingConfiguration } from 'src/core/helper/flat-routing-configuration';
import { ChargingSessionDataGrid } from 'src/feature/charging-session/charging-session-data-grid/charging-session.data-grid';
import { ChargePointList } from 'src/feature/charge-point/charge-point-list/charge-point-list';
import { InvoicePreview as InvoicePreviewV1 } from '@app/feature/invoice-v1/invoice-preview/invoice-preview';
import { InvoicePreview as InvoicePreviewV2 } from '@app/feature/invoice-v2/invoice-preview/invoice-preview';
import { ChargingSessionDetail } from 'src/feature/charging-session/charging-session-detail/charging-session-detail';
import { CustomerDetail } from 'src/feature/customer/customer-detail/customer-detail';
import { LogDataGrid } from 'src/feature/log/log-data-grid/log.data-grid';
import { DashboardView } from 'src/feature/dashboard/dashboard.view';
import FaceIcon from '@mui/icons-material/Face';
import DashboardIcon from '@mui/icons-material/Dashboard';
import RequestQuoteIcon from '@mui/icons-material/RequestQuote';
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import AdbIcon from '@mui/icons-material/Adb';
import EvStationIcon from '@mui/icons-material/EvStation';
import BoltIcon from '@mui/icons-material/Bolt';
import LogoDevIcon from '@mui/icons-material/LogoDev';
import GroupIcon from '@mui/icons-material/Group';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import DeviceHubIcon from '@mui/icons-material/DeviceHub';
import { QuarterOverview } from 'src/feature/quarter-overview/quarter-overview';
import PriceCheckIcon from '@mui/icons-material/PriceCheck';
import { TariffDemo } from 'src/feature/tariff/demo/tariff-demo';
import { CpoDataGrid } from 'src/feature/cpo/cpo-data-grid/cpo.data-grid';
import { CpoDetail as CpoDetails } from 'src/feature/cpo/cpo-details/cpo-details';

export const RoutingConfiguration: RoutingConfigurationModel[] = [
  {
    labelKey: 'dashboard.title',
    route: APP_PATH.DASHBOARD,
    controller: DashboardView,
    icon: <DashboardIcon />,
    showInMenu: true,
  },
  {
    labelKey: 'invoice-v1.list.title',
    route: APP_PATH.LIST_INVOICE_V1,
    controller: InvoiceDataGridV1,
    role: RoleEnum.OPERATOR,
    icon: <RequestQuoteIcon />,
    showInMenu: true,
  },
  {
    labelKey: 'invoice-v2.list.title',
    route: APP_PATH.LIST_INVOICE_V2,
    controller: InvoiceDataGridV2,
    role: RoleEnum.OPERATOR,
    icon: <RequestQuoteIcon />,
    showInMenu: true,
  },
  {
    labelKey: 'user.administrator.list.title',
    route: APP_PATH.LIST_ADMINISTRATOR,
    controller: AdministratorList,
    role: RoleEnum.SUPERADMIN,
    icon: <SupervisorAccountIcon />,
    showInMenu: true,
  },
  {
    labelKey: 'user.operator.list.title',
    route: APP_PATH.LIST_OPERATOR,
    controller: OperatorList,
    role: RoleEnum.ADMIN,
    icon: <FaceIcon />,
    showInMenu: true,
  },
  {
    labelKey: 'user.developer.list.title',
    route: APP_PATH.LIST_DEVELOPER,
    controller: DeveloperList,
    role: RoleEnum.SUPERADMIN,
    icon: <AdbIcon />,
    showInMenu: true,
  },
  {
    labelKey: 'customer.list.title',
    route: APP_PATH.LIST_CUSTOMER,
    controller: CustomerDataGrid,
    role: RoleEnum.OPERATOR,
    icon: <GroupIcon />,
    showInMenu: true,
  },
  {
    labelKey: 'customer.detail.title',
    route: APP_PATH.CUSTOMER_DETAIL,
    controller: CustomerDetail,
    role: RoleEnum.OPERATOR,
    icon: <GroupIcon />,
    showInMenu: false,
  },
  {
    labelKey: 'charging-session.list.title',
    route: APP_PATH.LIST_CHARGING_SESSION,
    controller: ChargingSessionDataGrid,
    role: RoleEnum.OPERATOR,
    icon: <BoltIcon />,
    showInMenu: true,
  },
  {
    labelKey: 'charge-point.list.title',
    route: APP_PATH.LIST_CHARGE_POINT,
    controller: ChargePointList,
    role: RoleEnum.OPERATOR,
    icon: <EvStationIcon />,
    showInMenu: true,
  },
  {
    labelKey: 'cpo.list.title',
    route: APP_PATH.LIST_CPO,
    controller: CpoDataGrid,
    role: RoleEnum.OPERATOR,
    icon: <DeviceHubIcon />,
    showInMenu: true,
  },
  {
    labelKey: 'cpo.details.title',
    route: APP_PATH.CPO_DETAILS,
    controller: CpoDetails,
    role: RoleEnum.OPERATOR,
    icon: <GroupIcon />,
    showInMenu: false,
  },
  {
    labelKey: 'invoice-v1.preview.title',
    route: APP_PATH.INVOICE_HTML_V1,
    controller: InvoicePreviewV1,
    role: RoleEnum.OPERATOR,
    icon: <RequestQuoteIcon />,
    showInMenu: false,
  },
  {
    labelKey: 'invoice-v2.preview.title',
    route: APP_PATH.INVOICE_HTML_V2,
    controller: InvoicePreviewV2,
    role: RoleEnum.OPERATOR,
    icon: <RequestQuoteIcon />,
    showInMenu: false,
  },
  {
    labelKey: 'charging-session.detail.title',
    route: APP_PATH.CHARGING_SESSION_DETAIL,
    controller: ChargingSessionDetail,
    role: RoleEnum.OPERATOR,
    icon: <BoltIcon />,
    showInMenu: false,
  },
  {
    labelKey: 'log.list.title',
    route: APP_PATH.LIST_LOG,
    controller: LogDataGrid,
    role: RoleEnum.DEVELOPER,
    icon: <LogoDevIcon />,
    showInMenu: true,
  },
  {
    labelKey: 'quarter-overview.title',
    route: APP_PATH.QUARTER_OVERVIEW,
    controller: QuarterOverview,
    role: RoleEnum.OPERATOR,
    icon: <AccountBalanceIcon />,
    showInMenu: true,
  },
  {
    labelKey: 'tariff.demo.title',
    route: APP_PATH.LIST_TARIFF,
    controller: TariffDemo,
    role: RoleEnum.OPERATOR,
    icon: <PriceCheckIcon />,
    showInMenu: true,
  },
];

export const FlatRoutingConfiguration =
  flatRoutingConfiguration(RoutingConfiguration);
